<template>
  <div
    class="
      flex
      items-center
      h-16
      py-4
      flex-shrink-0
      justify-center
      relative
      group
      shadow
    "
    :class="{
      'bg-dark': dark,
      'bg-grey-50': origin === 'groovepages'
    }"
  >
    <div class="p-2 rounded-lg" :class="{'shadow-lg': origin === 'groovepages'}">
      <component :is="logo" class="h-8 w-8" />
    </div>
    <div
      class="
        bg-white
        rounded-lg
        shadow-md
        top-full
        w-100
        border-solid border border-grey-200
        shadow
        overflow-y-auto
        top-0
        left-0
        absolute
        z-50
        hidden
        group-hover:block
        ml-2
      "
      style="max-height: 90vh; min-height: 24rem"
    >
      <div class="bg-white p-4">
        <div class="">
          <div class="relative">
            <div
              class="
                inline-flex
                shadow-sm
                rounded-md
                divide-x divide-indigo-600
              "
            >
              <div
                class="
                  relative
                  z-0
                  inline-flex
                  shadow-sm
                  rounded-md
                  divide-x divide-indigo-600
                "
              >
                <div class="relative inline-block text-left">
                  <div
                    class="
                      relative
                      inline-flex
                      items-center
                      bg-indigo-500
                      border border-transparent
                      rounded-l-md
                      shadow-sm
                      text-grey-700
                      cursor-pointer
                    "
                    @click="swithcApp()"
                  >
                    <p class="text-md font-semibold">
                      {{ selectedCategory.title }}
                    </p>
                    <!-- Heroicon name: solid/chevron-down -->
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div
                    v-if="openViewSwitcher"
                    v-on-click-outside="outSideMainMenu()"
                    class="
                      origin-top-right
                      absolute
                      left-0
                      mt-2
                      w-56
                      rounded-lg
                      shadow-md
                      border-solid border border-grey-200
                      shadow
                      bg-white
                      ring-opacity-5
                      focus:outline-none
                    "
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                    tabindex="-1"
                  >
                    <div class="py-1" role="none">
                      <a
                        v-for="(category, index) in switcherCategories"
                        :key="index"
                        @click="
                          (selectedCategory = category),
                            (openViewSwitcher = false)
                        "
                        href="#"
                        class="
                          text-grey-700
                          hover:bg-grey-100
                          block
                          px-4
                          py-2
                          text-sm
                        "
                        role="menuitem"
                        tabindex="-1"
                        id="menu-item-0"
                      >
                        {{ category.title }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <!-- hoveredCategoryApps(selectedCategory)" -->
            <a
              v-for="(app, index) in hoveredCategoryApps(selectedCategory)"
              :key="index"
              :href="app.url"
              class="
                -m-3
                p-3
                flex
                rounded-lg
                hover:bg-grey-100
                transition
                ease-in-out
                duration-150
              "
              :target="app.target"
              @click="handleRedirect($event, app.url, app.target)"
            >
              <div
                class="
                  flex flex-col
                  items-center
                  justify-center
                  border border-grey-100
                  rounded
                  h-10
                  w-10
                  shadow
                "
                v-if="app.logo"
              >
                <component :is="app.logo" class="flex-shrink-0 h-6 w-6" />
              </div>
              <div class="flex flex-col" :class="{ 'ml-3': app.logo }">
                <p class="text-sm font-semibold text-grey-700">
                  {{ app.title }}
                </p>
                <p class="text-xs text-grey-600">
                  {{ app.description }}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultiLevelDropdown from './MultiLevelDropdown';
import AcademyIcon from '../assets/academy-icon.svg';
import AcademyMenu from './AcademyMenu';
import SupportIcon from '../assets/support-icon.svg';
import SupportMenu from './SupportMenu';
import GdLogo from '../assets/logo-extra-small.svg';
import GroovePagesLogo from '../assets/groovepages-logo-small.svg';
import GrooveSellLogo from '../assets/groovesell-logo-small.svg';
import GrooveAffiliateLogo from '../assets/grooveaffiliate-logo-small.svg';
import GrooveMailLogo from '../assets/groovemail-logo-small.svg';
import GrooveMemberLogo from '../assets/groovemember-logo-small.svg';
import GrooveVideoLogo from '../assets/groovevideo-logo-small.svg';
import GrooveBlogLogo from '../assets/grooveblog-logo-small.svg';
import GrooveWebinarLogo from '../assets/groovewebinar-logo-small.svg';
import GrooveKartLogo from '../assets/groovekart-logo-small.svg';
import GrooveCopyLogo from '../assets/groovecopy-logo-small.svg';
import GrooveFunnelsLogo from '../assets/groovefunnels-logo-small.svg';
import GrooveMobileLogo from '../assets/MobileAppIcon.svg';
import GrooveAILogo from '../assets/grooveai-logo-small.svg';

export default {
  name: 'NavDropdown',
  components: {
    MultiLevelDropdown,
    AcademyIcon,
    AcademyMenu,
    SupportIcon,
    SupportMenu,
    GroovePagesLogo,
    GrooveSellLogo,
    GrooveAffiliateLogo,
    GrooveMailLogo,
    GrooveMemberLogo,
    GrooveVideoLogo,
    GrooveBlogLogo,
    GrooveWebinarLogo,
    GrooveCopyLogo,
    GrooveKartLogo,
    GdLogo,
    GrooveFunnelsLogo,
    GrooveMobileLogo,
  },
  props: {
    logo: {},
    dark: {
      default: true,
    },
    origin: {}
  },
  data() {
    return {
      mainMenu: true,
      childCategory: [],
      openApplicationSwitcher: false,
      selectedCategory: {
        title: 'Apps',
        description: 'All Groove Apps',
        logo: GrooveMemberLogo,
        type: 'apps',
      },
      openViewSwitcher: false,
    };
  },
  computed: {
    switcherCategories () {
      return [
        {
          title: 'Apps',
          description: 'All Groove Apps',
          logo: GrooveMemberLogo,
          type: 'apps',
        },
        {
          title: this.$t('frontend_nav_menu_apps_services'),
          description: this.$t('frontend_nav_menu_apps_services'),
          logo: GrooveMemberLogo,
          type: 'services',
        },
        {
          title: this.$t('frontend_nav_menu_apps_training'),
          description: this.$t('frontend_nav_menu_apps_training'),
          logo: GroovePagesLogo,
          type: 'training',
        },
        {
          title: this.$t('frontend_nav_menu_apps_social_media'),
          description: this.$t('frontend_nav_menu_apps_description_social_media'),
          logo: GrooveSellLogo,
          type: 'social',
        },
        {
          title: this.$t('frontend_nav_menu_apps_live_events'),
          description: this.$t('frontend_nav_menu_apps_description_live_events'),
          logo: GrooveMailLogo,
          type: 'events',
        },
        {
          title: this.$t('frontend_nav_menu_apps_support'),
          description: this.$t('frontend_nav_menu_apps_description_support'),
          logo: GrooveMailLogo,
          type: 'support',
        },
        {
          title: this.$t('frontend_nav_menu_apps_more_sites'),
          description: this.$t('frontend_nav_menu_apps_description_more_sites'),
          logo: GrooveMailLogo,
          type: 'more',
        },
      ];
    },
    apps () {
      return [
        {
          title: 'Dashboard',
          description: this.$t('frontend_nav_apps_description_dashboard'),
          url: '/#/',
          logo: GdLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'GroovePages',
          description: this.$t('frontend_nav_apps_description_groovepages'),
          url: '/groovepages/',
          logo: GroovePagesLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'GrooveFunnels',
          description: this.$t('frontend_nav_apps_description_groovefunnels'),
          url: '/groovepages/',
          logo: GrooveFunnelsLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'GrooveSell',
          description: this.$t('frontend_nav_apps_description_groovesell'),
          url: '/groovesell/',
          logo: GrooveSellLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'GrooveAffiliate',
          description: this.$t('frontend_nav_apps_description_grooveaffiliate'),
          url: '/groovesell/affiliates-dashboard',
          logo: GrooveAffiliateLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'GrooveMail',
          description: this.$t('frontend_nav_apps_description_groovemail'),
          url: '/groovemail/',
          logo: GrooveMailLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'GrooveMember',
          description: this.$t('frontend_nav_apps_description_groovemember'),
          url: '/groovemember/',
          logo: GrooveMemberLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'GrooveVideo',
          description: this.$t('frontend_nav_apps_description_groovevideo'),
          url: '/groovevideo/',
          logo: GrooveVideoLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'GrooveBlog',
          description: this.$t('frontend_nav_apps_description_grooveblog'),
          url: '/grooveblog/',
          logo: GrooveBlogLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'GrooveKart',
          description: this.$t('frontend_nav_apps_description_groovekart'),
          url: '/static/groovekart',
          logo: GrooveKartLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'Groove.ai',
          description: this.$t('frontend_nav_apps_description_grooveai'),
          url: 'https://groove.ai/',
          logo: GrooveAILogo,
          type: ['apps'],
          target: '_blank',
        },
        {
          title: 'GrooveWebinar',
          description: this.$t('frontend_nav_apps_description_groovewebinar'),
          url: '/groovewebinar/',
          logo: GrooveWebinarLogo,
          type: ['apps'],
          target: '_self',
        },
        {
          title: 'Mobile App',
          description: this.$t('frontend_nav_apps_description_mobileapp'),
          url: 'https://groove.how/apps/groove-cm-mobile-app/',
          logo: GrooveMobileLogo,
          type: ['apps'],
          target: '_blank',
        },
        {
          title: 'GrooveDigital Academy',
          description: this.$t('frontend_nav_apps_description_grooveacademy'),
          url: this.$t('official_link_academy'),
          type: ['training'],
          target: '_blank',
        },
        {
          title: this.$t('frontend_sites_side_bar_tutorials'),
          description: this.$t('frontend_nav_apps_description_tutorials'),
          url: this.$t('official_link_tutorials'),
          type: ['training'],
          target: '_blank',
        },
        {
          title: this.$t('frontend_support'),
          description: this.$t('frontend_nav_apps_description_support'),
          url: this.$t('official_link_support'),
          type: ['support'],
          target: '_blank',
        },
        {
          title: 'Groove.how',
          description: 'Groove.how',
          url: this.$t('official_link_tutorials'),
          type: ['support'],
          target: '_blank',
        },
        {
          title: 'GroovePay',
          description: this.$t('frontend_nav_apps_description_groovepay'),
          url: 'https://www.groovepay.com/',
          type: ['services'],
          target: '_blank',
        },
        {
          title: 'GrooveAds',
          description: this.$t('frontend_nav_apps_description_grooveads'),
          url: 'https://grooveads.com/',
          type: ['services'],
          target: '_blank',
        },
        {
          title: 'GrooveSolos',
          description: this.$t('frontend_nav_apps_description_groovesolos'),
          url: 'https://groovesolos.com/',
          type: ['services'],
          target: '_blank',
        },
        {
          title: 'GrooveKon',
          description: this.$t('frontend_nav_apps_description_groovekon'),
          url: 'https://groovekon.com/',
          type: ['events'],
          target: '_blank',
        },
        {
          title: 'The Marketers Cruise',
          description: this.$t('frontend_nav_apps_description_marketers_cruise'),
          url: 'https://marketerscruise.com/',
          type: ['events'],
          target: '_blank',
        },
        {
          title: 'Blog',
          description: this.$t('frontend_nav_apps_description_latest_news'),
          url: this.$t('official_link_blog'),
          type: ['more'],
          target: '_blank',
        },
        {
          title: 'GrooveDigital',
          description: this.$t('frontend_sites_side_bar_left_corporate_site'),
          url: this.$t('official_link_corporate'),
          type: ['more'],
          target: '_blank',
        },
        {
          title: 'GrooveGear',
          description: this.$t('frontend_nav_apps_description_groovegear'),
          url: 'https://groovegear.com/',
          type: ['more'],
          target: '_blank',
        },
        {
          title: 'GrooveJV',
          description: this.$t('frontend_baselayout_groove_partner_program'),
          url: 'https://groovejv.com/',
          type: ['more'],
          target: '_blank',
        },
        {
          title: 'Facebook Group',
          description: this.$t('frontend_nav_apps_description_fb_group'),
          url: this.$t('official_link_facebook_group'),
          type: ['social'],
          target: '_blank',
        },
        {
          title: 'Facebook Page',
          description: this.$t('frontend_nav_apps_description_fb_page'),
          url: 'https://www.facebook.com/groovefunnels/',
          type: ['social'],
          target: '_blank',
        },
        {
          title: 'Twitter',
          description: this.$t('frontend_nav_apps_description_twitter'),
          url: 'https://twitter.com/cm_groove',
          type: ['social'],
          target: '_blank',
        },
        {
          title: 'Youtube',
          description: this.$t('frontend_nav_apps_description_youtube'),
          url: 'https://www.youtube.com/channel/UCDjO_whAitBMCFUb6EJZO_g',
          type: ['social'],
          target: '_blank',
        },
        {
          title: 'Instagram',
          description: this.$t('frontend_nav_apps_description_instagram'),
          url: 'https://www.youtube.com/channel/UCDjO_whAitBMCFUb6EJZO_g',
          type: ['social'],
          target: '_blank',
        },
        {
          title: 'LinkedIn',
          description: this.$t('frontend_nav_apps_description_linkedin'),
          url: 'https://www.linkedin.com/company/groovedigital-software/mycompany/',
          type: ['social'],
          target: '_blank',
        },
      ];
    }
  },
  methods: {
    swithcApp() {
      this.openViewSwitcher = !this.openViewSwitcher;
    },
    outSideMainMenu() {
      console.log('clicked');
    },
    hideAllDropdowns() {},
    hoveredCategoryApps(type) {
      let selectedApps = [];
      if (type != '') {
        selectedApps = this.apps.filter((e) => {
          return e.type.includes(type.type);
        });
      }
      return selectedApps;
    },

    onMouseOver(name) {},

    onMouseLeave(name) {},
  },
  watch: {
    // selectedCategory(newValue){
    //   this.openViewSwitcher = false
    // if (newValue != '') {
    //    selectedApps = this.apps.filter((e) => {
    //      return e.type.includes(newValue);
    //    });
    //  }
    //   this.childCategory = selectedApps
    // },
    hoveredCategory(newValue) {
      if (newValue && newValue != '') {
        this.hoveredApps = this.apps.filter((e) => {
          console.log('this is e ');
          console.log(e);
          return e.type.includes(newValue);
        });
      } else {
        this.hoveredApps = [];
      }
      console.log('this is the hoveredapps');
      console.log(this.hoveredApps);
    },
  },
};

</script>
